import React, { useState } from "react";
import styles from "./PasswordBox.module.css";
import { Input } from "@progress/kendo-react-inputs";
export default function PasswordBox(props) {
  let {
    id,
    password,
    setPassword,
    isValid,
    placeholder,
    dataTestId = "test-password",
    className,
    disabled,
    maxLength
  } = props;
  const [passwordType, setPasswordType] = useState("password");
  const [localPassword, setLocalPassword] = useState(password);

  const onChange = (newPassword) => {
    setLocalPassword(newPassword);
    setPassword(newPassword);
  };

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  return (
    <div className={`${styles.passwordBox} ${className}`}>
      <Input
        type={passwordType}
        id={id}
        placeholder={placeholder}
        value={localPassword}
        valid={isValid}
        onChange={(event) => onChange(event.target.value)}
        data-testid={dataTestId}
        disabled={disabled}
        maxLength={maxLength}
      ></Input>
      <span onClick={togglePassword}>
        {passwordType === "password" ? (
          <i
            data-testid="test-password-toggle"
            className="fa fa-eye-slash fa-2x"
          ></i>
        ) : (
          <i data-testid="test-password-toggle" className="fa fa-eye fa-2x"></i>
        )}
      </span>
    </div>
  );
}
